import { schema } from 'normalizr';
const ACCOUNT_ENTITY_NAME = 'accounts';

export interface Consent {
  id?: string;
  documentId: string;
  date: Date;
}

export interface Account {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  consents?: Consent[];
  locale: string;
}

export interface AccountCreation {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  roles: string[];
  consents?: Consent[];
}

export type GoogleCalendarAuthorizations = 'readonly' | 'events';

export const accountLinkedEntities = [ACCOUNT_ENTITY_NAME];
export const accountSchema = new schema.Entity(ACCOUNT_ENTITY_NAME);
